import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_ENDPOINTS } from "../API/EndPoints";
import AxiosInstance from "../API/AxiosInstance";

export const getDoctorSlot = createAsyncThunk(
  "master/getAllDoctorSlots",
  async (credentials) => {
    const response = await AxiosInstance.get(
      API_ENDPOINTS.DOCTOR_AVAILABLE_SLOT,
      {
        params: credentials,
      }
    );
    return response.data;
  }
);

export const appointmentBooking = createAsyncThunk(
  "master/appointmentBooking",
  async (credentials) => {
    const token = localStorage.getItem("token");

    const endpoint = token
      ? API_ENDPOINTS.LOGIN_BOOKING
      : API_ENDPOINTS.GUEST_BOOKING;

    const headers = token ? { Authorization: `Bearer ${token}` } : {};

    const response = await AxiosInstance.post(endpoint, credentials, {
      headers,
    });

    return response.data;
  }
);

const doctorSlotSlice = createSlice({
  name: "getDoctorSlot",
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(getDoctorSlot.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDoctorSlot.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(getDoctorSlot.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default doctorSlotSlice.reducer;
